module.exports = __webpack_public_path__ + "static/media/john_hoppkins.984a92b9.jpg";